import { useContext } from 'react'
import { __ } from '@wordpress/i18n'
import SbUtils from '../../Utils/SbUtils';

const AddSourceModal = ( props ) => {
    const currentContext =  SbUtils.getCurrentContext();
    const {
        sbCustomizer,
        isPro,
    } = useContext( currentContext );

    setTimeout( () => {
        connectWithTikTok();
    }, 2500 );


    const connectWithTikTokAction = () => {
        const appendURL = sbCustomizer.isFeedEditor ?
            sbCustomizer.connectionURLs.stateURL + ',feed_id=' + sbCustomizer.feedData.feed_info.id : sbCustomizer.connectionURLs.stateURL;

        const urlParams = {
            'sbtt_con': sbCustomizer.connectionURLs.sbtt_con,
            'state': appendURL,
            'sbtt_connect_ver': sbCustomizer.connectionURLs?.sbtt_connect_ver || 1,
        };

        if(sbCustomizer.connectionURLs.sw_feed) {
            urlParams.sw_feed = 'true';
        }

        // Add email and version for Lindris onboarding.
        if (sbCustomizer.connectionURLs?.wordpress_user) {
            urlParams.wordpress_user = sbCustomizer.connectionURLs.wordpress_user;
        }
        if (sbCustomizer.connectionURLs?.v) {
            urlParams.v = sbCustomizer.connectionURLs.v;
        }

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = sbCustomizer.connectionURLs.page;

        for (const param in urlParams) {
            if (urlParams.hasOwnProperty(param)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = param;
                input.value = urlParams[param];
                form.appendChild(input);
            }
        }

        document.body.appendChild(form);
        form.submit();
    }

    const connectWithTikTok = () => {
        connectWithTikTokAction();
    }

    return (
        <div className="sb-addsource-modal sb-fs" data-pro={isPro}>
            <div className='sb-addsource-modal-tt'>
                <div className="sb-fb-source-redirect-ld sb-fb-fs">
                    <div></div>
                </div>
                <div className="sb-fb-source-redirect-info sb-fb-fs">
                    <strong className="sb-fb-fs">
                        {__('Redirecting to connect.smashballoon.com', 'sb-customizer')}
                    </strong>
                    <p className="sb-fb-fs">
                        {__('You will be redirected to our app so you can connect your account in 5 seconds', 'sb-customizer')}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default AddSourceModal;